// extracted by mini-css-extract-plugin
module.exports = {"table":"Table_table__ugrgE","spacing":"Table_spacing__N6ogk","row":"Table_row__yBd_r","row__col":"Table_row__col__xFBlN"};